import React, { createContext, useState, useEffect, useCallback } from "react";
import { getEmergencyPatients } from "../services/getEmergencyPatients";
import { useValidToken } from "../../../hooks/useValidToken";

export const EmergencyContext = createContext();

const INITIAL_FILTERS = {
  cipId: null,
  locationId: null,
  searchName: null,
  dateOfBirth: null,
  minLace: null,
  facilityName: null,
  dateFrom: null,
  dateTo: null,
};

export const EmergencyProvider = ({ children }) => {
  const [emergencyPatients, setEmergencyPatients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [filters, setFilters] = useState(INITIAL_FILTERS);

  const { isValid, authLoading } = useValidToken();

  const updateFilter = useCallback((key, value) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
  }, []);

  const resetFilters = useCallback(() => setFilters(INITIAL_FILTERS), []);

  useEffect(() => {
    const fetchData = async () => {
      if (authLoading || !isValid) return;

      setLoading(true);
      setError(null);

      try {
        const data = await getEmergencyPatients(filters);
        setEmergencyPatients(Array.isArray(data) ? data : []);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [authLoading, isValid, filters]);

  return (
    <EmergencyContext.Provider
      value={{
        emergencyPatients,
        loading,
        error,
        filters,
        updateFilter,
        resetFilters,
      }}
    >
      {children}
    </EmergencyContext.Provider>
  );
};
